module.exports = __webpack_public_path__ + "img/about.baf1cc07.jpg";